// Mock data for KIPAY Mobile App

export const mockUser = {
  id: "usr_001",
  firstName: "Amadou",
  lastName: "Koné",
  phone: "+225 07 08 09 10 11",
  email: "amadou.kone@email.ci",
  avatar: null,
  level: "Silver",
  cardNumber: "**** **** **** 4589",
  cardStatus: "active", // active, blocked, expired
  memberSince: "2024-03-15"
};

export const mockPoints = {
  total: 12450,
  pending: 250,
  expiring: 1500,
  expiryDate: "2025-06-30",
  monthlyGain: 1250,
  levelProgress: 65, // percentage to next level
  nextLevel: "Gold",
  pointsToNextLevel: 7550
};

export const mockTransactions = [
  {
    id: "txn_001",
    type: "credit",
    amount: 25000,
    points: 50,
    merchant: "Wayne Station Cocody",
    category: "carburant",
    date: "2025-01-19T14:32:00",
    status: "completed"
  },
  {
    id: "txn_002",
    type: "credit",
    amount: 150000,
    points: 300,
    merchant: "EKIPTECH Store",
    category: "technologie",
    date: "2025-01-18T10:15:00",
    status: "completed"
  },
  {
    id: "txn_003",
    type: "debit",
    amount: -5000,
    points: -100,
    merchant: "Échange Points",
    category: "recompense",
    date: "2025-01-17T16:45:00",
    status: "completed"
  },
  {
    id: "txn_004",
    type: "credit",
    amount: 30000,
    points: 60,
    merchant: "Wayne Station Plateau",
    category: "carburant",
    date: "2025-01-15T09:20:00",
    status: "completed"
  },
  {
    id: "txn_005",
    type: "credit",
    amount: 500000,
    points: 750,
    merchant: "KIDH - Réservation",
    category: "immobilier",
    date: "2025-01-10T11:00:00",
    status: "completed"
  },
  {
    id: "txn_006",
    type: "credit",
    amount: 20000,
    points: 40,
    merchant: "Wayne Station Marcory",
    category: "carburant",
    date: "2025-01-08T18:30:00",
    status: "completed"
  }
];

export const mockOffers = [
  {
    id: "off_001",
    title: "Double Points ce weekend",
    description: "Gagnez x2 points sur tous vos achats Wayne",
    validUntil: "2025-01-26",
    type: "bonus",
    image: null
  },
  {
    id: "off_002",
    title: "-10% chez EKIPTECH",
    description: "Sur tous les produits domotique",
    validUntil: "2025-01-31",
    type: "discount",
    image: null
  },
  {
    id: "off_003",
    title: "Plein gratuit",
    description: "500 points = 1 plein de 20 000 FCFA",
    validUntil: "2025-02-28",
    type: "reward",
    image: null
  }
];

export const mockNotifications = [
  {
    id: "notif_001",
    title: "Transaction réussie",
    message: "Vous avez gagné 50 points chez Wayne Station Cocody",
    date: "2025-01-19T14:32:00",
    read: false,
    type: "transaction"
  },
  {
    id: "notif_002",
    title: "Nouvelle offre disponible",
    message: "Double points ce weekend sur tous vos achats Wayne !",
    date: "2025-01-19T09:00:00",
    read: false,
    type: "offer"
  },
  {
    id: "notif_003",
    title: "Points bientôt expirés",
    message: "1 500 points expirent le 30 juin 2025",
    date: "2025-01-18T10:00:00",
    read: true,
    type: "alert"
  }
];

// Simulate OTP verification
export const verifyOTP = (phone, otp) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      // Mock: any 6-digit code works
      if (otp.length === 6 && /^\d+$/.test(otp)) {
        resolve({ success: true, user: mockUser });
      } else {
        reject({ success: false, message: "Code invalide" });
      }
    }, 1500);
  });
};

// Simulate sending OTP
export const sendOTP = (phone) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log(`OTP sent to ${phone}: 123456 (mock)`);
      resolve({ success: true, message: "Code envoyé" });
    }, 1000);
  });
};
